import { ChevronDown, Mail, Phone } from 'lucide-react';
import type { VerificationSnapshot } from './verificationApi';

export function HostedNumberHelp({ business, reserved = false }: { business: VerificationSnapshot['business']; reserved?: boolean }) {
  const subject = `Use my existing business number with Chekkit — ${business.name}`;
  const body = [
    'Hi Chekkit support,', '',
    'I’d like to text from my existing business number while keeping my current calling service. Could you check whether my number is eligible and help me with setup?', '',
    `Business: ${business.name}`,
    `Country: ${business.country === 'CA' ? 'Canada' : 'United States'}`,
    `Existing business phone number: ${business.phone || '[add your number]'}`,
    'Current phone provider: [add your provider]',
    ...(reserved ? ['I have already reserved a new number during signup and would like help reviewing my options.'] : []),
    '', 'Thank you!',
  ].join('\n');
  const email = `mailto:support@chekkit.io?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  return <details className="sv-hosted-help">
    <summary><Phone size={17} aria-hidden="true" /><span>Already have a business number?</span><ChevronDown size={16} className="sv-hosted-chevron" aria-hidden="true" /></summary>
    <div>
      <p>Keep the number your customers know. We may be able to add texting to your existing landline or toll-free number while your calls stay with your current provider.</p>
      <p>{reserved ? 'Our team can help you review your number options.' : 'Contact us before choosing a new number.'} We’ll check eligibility and guide you through ownership verification. Mobile numbers aren’t eligible for this option.</p>
      <a href={email}><Mail size={17} aria-hidden="true" />Ask us about my number</a>
      <small>Opens an email to support@chekkit.io with the details started for you. You can edit it before sending.</small>
    </div>
  </details>;
}
